import {Box, Grid, Typography} from '@mui/material';
import {notEmpty} from 'main/utility/CommonUtil';
import {getObjectValue} from 'main/utility/LayoutUtil';
import PropTypes from 'prop-types';

// Internal helper for the signature lines
const Signature = ({label}) => (
  <Grid item xs={4.5}>
    <Box sx={{textAlign: 'center'}}>
      <Box
        sx={{
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          width: '100%',
          mb: 2,
        }}
      />
      <Typography
        sx={{fontSize: 12, fontWeight: 700, textTransform: 'uppercase'}}
      >
        {label}
      </Typography>
    </Box>
  </Grid>
);

Signature.propTypes = {
  label: PropTypes.node.isRequired,
};

const DocFooter = ({widgetSpec, widgetData}) => {
  const {footer} = widgetSpec;
  const {companysign, clientsign, invoicenote = {}} = footer;
  const addCompanySign = notEmpty(companysign);
  const addClientSign = notEmpty(clientsign);

  return (
    <Box sx={{width: '100%'}}>
      {/* Signature Section */}
      <Grid
        container
        spacing={6}
        justifyContent={
          addCompanySign && addClientSign ? 'space-between' : 'flex-end'
        }
        sx={{mb: 8, px: 4}}
      >
        {addCompanySign && (
          <Signature
            label={getObjectValue(widgetData, companysign) || companysign}
          />
        )}

        {addClientSign && (
          <Signature
            label={getObjectValue(widgetData, clientsign) || clientsign}
          />
        )}
      </Grid>

      {/* Legal Disclaimer / Note */}
      {notEmpty(invoicenote) && (
        <Box sx={{textAlign: 'center', px: 4}}>
          <Typography
            sx={{
              fontSize: 11,
              color: 'text.secondary',
              fontStyle: 'italic',
              lineHeight: 1.6,
            }}
          >
            <Box
              component='span'
              sx={{
                fontWeight: 700,
                color: 'text.primary',
                textTransform: 'uppercase',
                mr: 1,
              }}
            >
              {invoicenote.label}
            </Box>
            {invoicenote.value}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

DocFooter.propTypes = {
  widgetSpec: PropTypes.object,
  widgetData: PropTypes.object,
};

export default DocFooter;
